import {lazyWithChunkRetry} from '../utility/chunkLoadRecovery';
import AthleteProfile from './common/AthleteProfile';
const SignIn = lazyWithChunkRetry(() => import('./beforeLogin/SignIn'));
// const SignUp = lazyWithChunkRetry(() => import("./beforeLogin/SignUp"));
const ForgotPassword = lazyWithChunkRetry(() => import('./beforeLogin/ForgotPassword'));
const PublicBooking = lazyWithChunkRetry(() => import('./afterLogin/PublicBooking'));
const ClientDashboard = lazyWithChunkRetry(() => import('./afterLogin/ClientDashboard'));
const ConfirmBookingPage = lazyWithChunkRetry(() => import('./afterLogin/ConfirmBookingPage'));
const Booking = lazyWithChunkRetry(() => import('./afterLogin/Booking'));
const RescheduleAppointment = lazyWithChunkRetry(() =>
  import('./afterLogin/RescheduleAppointment')
);
const FamilyMembers = lazyWithChunkRetry(() => import('./afterLogin/FamilyMembers'));
const PaymentPage = lazyWithChunkRetry(() => import('./afterLogin/PaymentPage'));
const Favorites = lazyWithChunkRetry(() => import('./afterLogin/Favorites'));
const SavedCards = lazyWithChunkRetry(() => import('./afterLogin/SavedCards'));
const Credits = lazyWithChunkRetry(() => import('./afterLogin/Credits'));
const Orders = lazyWithChunkRetry(() => import('./afterLogin/Orders'));
const Memberships = lazyWithChunkRetry(() => import('./afterLogin/Memberships'));
const Invoices = lazyWithChunkRetry(() => import('./afterLogin/Invoices'));
const EmailPreferences = lazyWithChunkRetry(() => import('./afterLogin/EmailPreferences'));
const Documents = lazyWithChunkRetry(() => import('./afterLogin/Documents'));
const Workouts = lazyWithChunkRetry(() => import('./afterLogin/Workouts'));

const Explore = lazyWithChunkRetry(() => import('./afterLogin/Explore'));
const Details = lazyWithChunkRetry(() => import('./afterLogin/Details'));
const Waiver = lazyWithChunkRetry(() => import('./common/Waiver'));
const PostBookingConfirmation = lazyWithChunkRetry(() =>
  import('./afterLogin/PostBookingConfirmation')
);
const InstallmentsCardUpdate = lazyWithChunkRetry(() =>
  import('./Others/InstallmentsCardUpdate/CardUpdate')
);
const CheckIn = lazyWithChunkRetry(() => import('./Others/CheckIn'));
const MemberRegistration = lazyWithChunkRetry(() => import('./Others/MemberRegistration'));
const MemberRegistrationCreateForm = lazyWithChunkRetry(() =>
  import('./Others/MemberRegistration/MemberRegistrationCreateForm')
);
const MemberQuestionnaire = lazyWithChunkRetry(() =>
  import('./Others/MemberQuestionnaire/MemberQuestionnaire')
);
const PostSignUp = lazyWithChunkRetry(() => import('./beforeLogin/PostSignUp'));
// import ChatPage from "./afterLogin/ChatPage";
// import CoachDashboard from "./afterLogin/CoachDashboard";

export {
  AthleteProfile,
  // SignUp,
  Booking,
  CheckIn,
  ClientDashboard,
  ConfirmBookingPage,
  Details,
  Explore,
  FamilyMembers,
  Favorites,
  ForgotPassword,
  InstallmentsCardUpdate,
  MemberRegistration,
  MemberRegistrationCreateForm,
  MemberQuestionnaire,
  PaymentPage,
  PostBookingConfirmation,
  PostSignUp,
  PublicBooking,
  RescheduleAppointment,
  SignIn,
  Waiver,
  SavedCards,
  Credits,
  Orders,
  Memberships,
  Invoices,
  EmailPreferences,
  Documents,
  Workouts,
};
